import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, freddyTheme, Typography } from '@coolblue-development/freddy';
import { useTranslation } from '../../i18n/useTranslation.js';
export const PriceFormatter = ({ size, variant, price, withEuroSign = false, isFormerPrice = false, withoutStrikethrough = false, }) => {
    const { t } = useTranslation('salesPriceCurrent');
    if (price == null)
        return null;
    if (price === 0 && variant === 'regular') {
        return (_jsx(Typography, { m: 0, fontWeight: 700, color: "accented", component: "span", children: t('free') }));
    }
    const isRoundPrice = Number.isInteger(price);
    const formattedPrice = new Intl.NumberFormat('nl-NL', {
        minimumFractionDigits: isRoundPrice ? 0 : 2,
        maximumFractionDigits: 2,
    }).format(price);
    return (_jsxs(Box, { component: "span", sx: {
            whiteSpace: 'nowrap',
            position: 'relative',
            ...(isFormerPrice &&
                !withoutStrikethrough && {
                '::before': {
                    content: "''",
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    top: '50%',
                    transform: 'rotate(-10deg)',
                    boxSizing: 'border-box',
                    borderTop: `${size === 'small' ? freddyTheme.borderWidth[25] : freddyTheme.borderWidth[50]} solid ${freddyTheme.color.font.subtle}`,
                },
            }),
        }, children: [withEuroSign ? '€ ' : '', formattedPrice, isRoundPrice && _jsx(_Fragment, { children: ",-" })] }));
};
//# sourceMappingURL=PriceFormatter.js.map